import { isWebview } from "@elparking/utils"

export default isWebview
